// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchResults__root--2LoMJ","storyList":"SearchResults__storyList--3U6RN"};